/* 3DBPOINT — pagina prodotto: varianti, galleria, quantità, file */
(function () {
  function money(cents, format) {
    var v = (cents / 100).toFixed(2).split('.');
    var intDot = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var intComma = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var map = {
      amount: intComma + '.' + v[1],
      amount_no_decimals: intComma,
      amount_with_comma_separator: intDot + ',' + v[1],
      amount_no_decimals_with_comma_separator: intDot,
      amount_with_apostrophe_separator: v[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + v[1]
    };
    return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) { return map[k] || map.amount; });
  }

  function init(root) {
    var form = root.querySelector('form[data-tdb-form]');
    if (!form) return;
    var dataEl = root.querySelector('[data-tdb-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var format = root.getAttribute('data-money-format');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-tdb-price]');
    var compareEl = root.querySelector('[data-tdb-compare]');
    var btn = form.querySelector('[data-tdb-add]');
    var groups = form.querySelectorAll('[data-tdb-optgroup]');
    var mainImg = root.querySelector('[data-tdb-main]');
    var thumbs = root.querySelectorAll('[data-tdb-thumb]');

    function showMedia(id) {
      for (var i = 0; i < thumbs.length; i++) {
        var t = thumbs[i];
        var on = String(t.getAttribute('data-media-id')) === String(id);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.src = t.getAttribute('data-src');
        }
      }
    }
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].addEventListener('click', function () { showMedia(this.getAttribute('data-media-id')); });
    }

    form.addEventListener('change', function (e) {
      if (!e.target.hasAttribute('data-tdb-option')) return;
      var selected = [];
      for (var g = 0; g < groups.length; g++) {
        var c = groups[g].querySelector('input:checked');
        selected.push(c ? c.value : null);
        var label = groups[g].querySelector('[data-tdb-selected]');
        if (label && c) label.textContent = c.value;
      }
      var v = null;
      for (var k = 0; k < variants.length; k++) {
        var ok = true;
        for (var o = 0; o < selected.length; o++) {
          if (variants[k].options[o] !== selected[o]) { ok = false; break; }
        }
        if (ok) { v = variants[k]; break; }
      }
      if (!v) { btn.disabled = true; btn.textContent = 'Non disponibile'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, format);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price, format);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label') : 'Esaurito';
      if (v.featured_media) showMedia(v.featured_media.id);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) {}
    });

    var qty = form.querySelector('input[name="quantity"]');
    var qbtns = form.querySelectorAll('[data-tdb-qty]');
    for (var q = 0; q < qbtns.length; q++) {
      qbtns[q].addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(this.getAttribute('data-tdb-qty'), 10);
        qty.value = Math.max(1, n);
      });
    }

    var date = form.querySelector('input[type="date"]');
    if (date) {
      var d = new Date();
      d.setDate(d.getDate() + 2);
      date.min = d.toISOString().slice(0, 10);
    }

    var file = form.querySelector('input[type="file"]');
    var fileMsg = root.querySelector('[data-tdb-file-msg]');
    if (file) {
      file.addEventListener('change', function () {
        var f = file.files && file.files[0];
        if (f && f.size > 20 * 1024 * 1024) {
          file.value = '';
          if (fileMsg) { fileMsg.textContent = 'Il file supera i 20 MB: inviacelo via email dopo l’ordine.'; fileMsg.style.color = '#7F1D1D'; }
        } else if (fileMsg) {
          fileMsg.textContent = f ? 'File pronto: ' + f.name : fileMsg.getAttribute('data-default');
          fileMsg.style.color = '';
        }
      });
    }

    form.addEventListener('submit', function () {
      if (btn) { btn.disabled = true; btn.textContent = 'Aggiunta in corso…'; }
    });
    window.addEventListener('pageshow', function () {
      if (btn && btn.textContent === 'Aggiunta in corso…') {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-label');
      }
    });
  }

  var roots = document.querySelectorAll('[data-tdb-product]');
  for (var r = 0; r < roots.length; r++) init(roots[r]);
})();